import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c82b184"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Ever wanted to buy an NFT off someone but didn't know who they were / how to contact them? Send them an NFT with your contact details - maybe they'll reach out ¯\\_(ツ)_/¯ ", -1))
const _hoisted_2 = { class: "mt-10" }
const _hoisted_3 = { class: "flex mt-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "nftName" }, "NFT name:")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "contactDets",
    class: "mt-5"
  }, "Contact Details:")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "textSize",
    class: "mt-5"
  }, "Text Size:")
], -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Mint successful! 🎉", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Loading your new NFT... (might take a min or two)")
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StdNotifications = _resolveComponent("StdNotifications")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_ExplorerLink = _resolveComponent("ExplorerLink")!
  const _component_NFTViewCard = _resolveComponent("NFTViewCard")!
  const _component_NotifySuccess = _resolveComponent("NotifySuccess")!
  const _component_ContentTooltipIWantUrNFT = _resolveComponent("ContentTooltipIWantUrNFT")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "#",
        class: "nes-text is-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal('tooltipWant')))
      }, "How does it work? ")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mintNewMaster && _ctx.mintNewMaster(...args)), ["prevent"])),
        class: "flex-grow"
      }, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "nftName",
            class: "nes-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nftName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.nftName]
          ])
        ]),
        _hoisted_5,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "contactDets",
            class: "nes-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactDets) = $event))
          }, null, 512), [
            [_vModelText, _ctx.contactDets]
          ])
        ]),
        _hoisted_6,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            id: "textSize",
            class: "nes-input",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.textSize) = $event))
          }, null, 512), [
            [_vModelText, _ctx.textSize]
          ])
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(["nes-btn is-primary mt-5", { 'is-disabled': _ctx.isLoading || !_ctx.isConnected }]),
          disabled: _ctx.isLoading || !_ctx.isConnected,
          type: "submit"
        }, " Mint NFT ", 10, _hoisted_7)
      ], 32),
      _createElementVNode("div", {
        class: "display",
        id: "canvas",
        style: _normalizeStyle({ fontSize: `${_ctx.textSize}px` })
      }, [
        _createElementVNode("p", null, "I want ur " + _toDisplayString(_ctx.nftName) + " NFT.", 1),
        _createElementVNode("p", _hoisted_8, "Hmu " + _toDisplayString(_ctx.contactDets), 1)
      ], 4)
    ]),
    _createVNode(_component_StdNotifications, {
      "is-connected": _ctx.isConnected,
      "is-loading": _ctx.isLoading,
      error: _ctx.error
    }, null, 8, ["is-connected", "is-loading", "error"]),
    (_ctx.mintResult)
      ? (_openBlock(), _createBlock(_component_NotifySuccess, {
          key: 0,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            (!_ctx.newNFT)
              ? (_openBlock(), _createBlock(_component_LoadingIcon, {
                  key: 0,
                  align: "left",
                  class: "mt-5"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_ExplorerLink, {
                    "tx-id": _ctx.mintResult.txId
                  }, null, 8, ["tx-id"]),
                  _createVNode(_component_NFTViewCard, {
                    n: _ctx.newNFT,
                    class: "text-black"
                  }, null, 8, ["n"])
                ]))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isModalVisible('tooltipWant'))
      ? (_openBlock(), _createBlock(_component_ModalWindow, {
          key: 1,
          title: "How does it work?",
          onHideModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideModal('tooltipWant')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ContentTooltipIWantUrNFT)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}